export const CIVIL_STATUS = {
  SINGLE: 'Soltero',
  UNION: 'Union libre',
  MARRIED: 'Casado',
  SEPARATED: 'Separado',
  WIDOWED: 'Viudo',
};

export const CIVIL_STATUS_OPTIONS = [
  CIVIL_STATUS.SINGLE,
  CIVIL_STATUS.UNION,
  CIVIL_STATUS.MARRIED,
  CIVIL_STATUS.SEPARATED,
  CIVIL_STATUS.WIDOWED,
];

export const CIVIL_STATUS_SELECT_OPTIONS = CIVIL_STATUS_OPTIONS.map((opt) => ({
  key: opt,
  text: opt,
  value: opt,
}));
